/* =========================================================================
   Root Cause — Offer page JS
   Scoped to .rc-offer-* sections. Safe to load multiple times (guarded).
   Interacts with .rc-qty-card / .rc-atc-btn contract (rc-trust-page.js).
   ========================================================================= */
(function () {
  'use strict';
  if (window.__rcOfferLoaded) return;
  window.__rcOfferLoaded = true;

  /* ---------- Shared countdown (persistent 48h window) ---------- */
  var COUNTDOWN_KEY = 'rc_offer_end';
  var end = parseInt(localStorage.getItem(COUNTDOWN_KEY) || '0', 10);
  var now = Date.now();
  if (!end || end < now) {
    end = now + (2 * 24 + 14) * 3600 * 1000 + 32 * 60 * 1000 + 18 * 1000;
    localStorage.setItem(COUNTDOWN_KEY, end);
  }
  var pad = function (n) { return String(n).padStart(2, '0'); };
  function tick() {
    var diff = Math.max(0, end - Date.now());
    var d = Math.floor(diff / 86400000); diff -= d * 86400000;
    var h = Math.floor(diff / 3600000); diff -= h * 3600000;
    var m = Math.floor(diff / 60000); diff -= m * 60000;
    var s = Math.floor(diff / 1000);
    document.querySelectorAll('[data-rc-offer-d]').forEach(function (el) { el.textContent = pad(d); });
    document.querySelectorAll('[data-rc-offer-h]').forEach(function (el) { el.textContent = pad(h); });
    document.querySelectorAll('[data-rc-offer-m]').forEach(function (el) { el.textContent = pad(m); });
    document.querySelectorAll('[data-rc-offer-s]').forEach(function (el) { el.textContent = pad(s); });
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- Rotating promo messages ---------- */
  document.querySelectorAll('.rc-offer-announcement__rotator').forEach(function (rotator) {
    var slides = rotator.querySelectorAll('.rc-offer-announcement__slide');
    if (slides.length < 2) return;
    var i = 0;
    slides[0].classList.add('is-active');
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 6000);
  });

  /* ---------- Delivery day label ---------- */
  (function () {
    var el = document.querySelector('[data-rc-deliver-day]');
    if (!el) return;
    var n = new Date();
    var hour = n.getHours();
    var prefix = hour >= 22 ? (el.getAttribute('data-rc-overmorgen') || 'overmorgen') : (el.getAttribute('data-rc-morgen') || 'morgen');
    el.textContent = prefix;
  })();

  /* ---------- Hero gallery (thumb strip + main image swap) ---------- */
  document.querySelectorAll('.rc-offer-hero__gallery').forEach(function (gal) {
    var main = gal.querySelector('.rc-offer-hero__main-img');
    var thumbs = gal.querySelectorAll('.rc-offer-hero__thumb');
    if (!main || thumbs.length === 0) return;
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.src = full;
        var alt = thumb.getAttribute('data-alt');
        if (alt) main.alt = alt;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Sticky bottom CTA reveal ---------- */
  (function () {
    var stk = document.querySelector('.rc-offer-sticky');
    var hero = document.querySelector('.rc-offer-hero');
    var closer = document.querySelector('.rc-offer-closer');
    if (!stk || !hero) return;
    function check() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var closerRect = closer ? closer.getBoundingClientRect() : null;
      var inCloser = closerRect && closerRect.top < window.innerHeight * 0.7 && closerRect.bottom > 0;
      if (heroBottom < 0 && !inCloser) stk.classList.add('is-visible');
      else stk.classList.remove('is-visible');
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  /* ---------- Sticky / closer CTA → smooth-scroll to hero CTA ---------- */
  document.querySelectorAll('[data-rc-scroll-cta]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var target = document.querySelector('.rc-offer-hero__cta');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
})();
